module.exports = __webpack_public_path__ + "media/images/partner/media/digitalhubcologne-86d51547e98cb96e41c4a2e9a40e5edf.png";